// extracted by mini-css-extract-plugin
export default {"address":"wRRRO","field":"ojd68"};